import { render, staticRenderFns } from "./OsTemplateList.vue?vue&type=template&id=128f23f2&scoped=true"
import script from "./OsTemplateList.vue?vue&type=script&lang=js"
export * from "./OsTemplateList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "128f23f2",
  null
  
)

export default component.exports